<template>
  <div class="navbar">
    <div class="goback" @click="routerTo" style="cursor: pointer;">
      3D虚拟仿真实验室
    </div>
    <breadcrumb class="breadcrumb-container"/>
    <!-- <div class="contact">
      <ul>
        <li><svg-icon icon-class="version"/></li>
        <li @click="openPay" style="cursor:pointer">订阅</li>
      </ul>
    </div> -->
    <div class="right-menu">
      <!-- <template v-if="device!=='mobile'">
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>
      </template> -->
      <el-dropdown class="avatar-container right-menu-item" trigger="hover">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/expand">
            <el-dropdown-item>
              回到首页
            </el-dropdown-item>
          </router-link>
          <router-link to="/personalExpand" v-if="this.tenantSet.tenantInfo == 1">
            <el-dropdown-item>
              <span>个人中心</span>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span @click="openExternal">联系客服</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <transition name="el-fade-in-linear">
      <pay @payNone="payNone" v-if="isShowSettlement"></pay>
    </transition> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Screenfull from '@/components/Screenfull'
import request from '@/utils/request'
import Cookies from 'js-cookie'
// import pay from './pay'

export default {
  components: {
    Breadcrumb,
    Screenfull,
    // pay
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'avatar',
      'device',
    ])
  },
  // 跳转首页刷新页面
  inject:['reload'],
  data(){
    return {
      isShowSettlement:false,
      tenantSet:{},
      isShowLang:false,
      lang:'简体中文',
      isShowE:'',
      position:1,
      opened:true,
      option:[{
          value: '全部',
          label: '全部'
        }, {
          value: '同步',
          label: '同步'
        }, {
          value: '探究',
          label: '探究'
        }],
      switchs:'全部',
      switchs2:'全部',
      tenantId:'',
    }
  },
  created(){
    this.getinfo();
  },
  methods: {
    openPay(){
      
    },
    payNone(val){
      this.isShowSettlement = false;
    },
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.tenantId = res.tenant.id
        this.isShowE = res.jwtUser.activity
        this.tenantSet = res.tenant
      })
    },
    // 活动入口
    entrance(){
      // 生产
      window.open("http://192.168.0.133:8001/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
      // 测试
      // window.open("http://221.231.139.161:8011/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
    },
    openExternal(){
      window.open("http://wpa.qq.com/msgrd?v=3&uin=3512883254&site=qq&menu=yes","_blank")
    },
    // 跳转首页刷新页面
    routerTo(){
      this.$router.push({path:'/expand'});
      // this.$router.push({path:'/'})
      // this.reload();
    },
    toggleSideBar(){
      // this.$store.dispatch('ToggleSideBar')
      this.opened=!this.opened
    },
    logout() {
        this.$store.dispatch('LogOutT').then(() => {
          if(this.tenantId == 38){
            // this.$router.push({path:'/partyLCAH'});
            window.location.href="https://www.anhuiwx.cn";
          }else{
            this.$router.push({path:'/partyLC'});
          }
          Cookies.remove('userOrder');
          this.reload() // 为了重新实例化vue-router对象 避免bug
        })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.lang-dropdown{
  color: #f8d3c0;
}
.lang-dropdown:hover{
  color: #fff;
}
.goback{
  margin-left: 16px;
  font-size: 24px;
  color: #FFF;
  float: left;
  line-height: 60px;
}
.switch{
  width: 50px;
  height: 100%;
  float: left;
  line-height: 60px;
}
.switch /deep/ .el-input__suffix{
  display: none;
}
.switch /deep/ .el-input--suffix .el-input__inner{
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  border-color: #F38F38 ;
  background-color: rgba(233, 238, 242, .4);
  color: rgb(240, 234, 234);
}
.svg-icon{
  width: 100% !important;
  height: 100% !important;
  padding-top: 2px;
  padding-bottom: 2px;
}
// .goback img{
//   width: 120px;
//   height: 46px;
//   margin-top: 7px;
// }
.goback img{
  // width: 120px;
  // height: 46px;
  margin-top: 4px;
}
  .navbar {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
    height: 60px;
    background: linear-gradient(to right, rgb(241, 152, 73) 10%, rgb(236, 111, 40) 100%);
    border-bottom: 1px solid #f1ad4e;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 60px;
      float: left;
      padding: 0 10px;
    }
   .app-breadcrumb.el-breadcrumb{
     display: none;
   }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right !important;
      height: 100%;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 60px;
        margin-right: 30px;
        .avatar-wrapper {
          margin-top: 9px;
          position: relative;
          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
.contact{
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  height: 24px;
}
.contact ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.contact ul li{
  color: #fff;
  float:left;
  padding-right:5px;
  font-size: 12px;
  width: 22px;
  height:24px;
  line-height: 24px;
}
.contact ul li:last-of-type{
  padding-right:0;
  padding-left: 0;
  border-right:none;
  width:60px;
  font-size: 14px;
}
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #fef7ed;
    color: #F38F38;
  }
  // .el-select-dropdown{
  //   margin-top: -8px !important;
  //   left: 170px !important;
  // }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color:#fef7ed;
  }
  .el-select-dropdown__item.selected{
    color: #F38F38;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/NavbarCharge.vue